/**
 * Everything about this site that is a fact rather than a sentence.
 *
 * The copy modules read from here so a name, an address or a store link is written
 * once. `scripts/prerender.mjs` keeps its own copy of SITE_URL because it runs in
 * plain Node before the bundle exists; if you change the host, change it there too.
 */

export const SITE_URL = 'https://ronin.diabetesninja.se'
export const SITE_NAME = 'Ronin'

/**
 * Who publishes Ronin.
 *
 * Venueve AB, which also builds DiabetesNinja and runs NattNinja. This is deliberately
 * NOT the association that publishes diabetesninja.se: Ronin is the company's app, and
 * the privacy notice names Venueve AB as the data controller on that basis. If that ever
 * changes, it changes here and in the two legal documents at the same time, because a
 * notice that names the wrong controller is worse than one that names none.
 */
export const ORG_NAME = 'Venueve AB'
export const ORG_NUMBER = '556872-6326'
export const ORG_CITY = 'Limhamn'
export const SUPPORT_EMAIL = 'support@diabetesninja.se'

/**
 * The street address, which e-handelslagen (2002:562) 8 § wants next to the name and the
 * e-mail address. Empty until it is confirmed; while it is, the legal pages and the
 * contact page leave the line out rather than print a blank one, the same way the store
 * badges handle the empty URLs below. The city and country still show, so the entity is
 * identifiable either way.
 */
export const ORG_ADDRESS = ''

/**
 * The sibling app. Ronin's footer links across to it so a visitor can see the two come
 * from the same place, and diabetesninja.se links back from a box on its start page and
 * from its footer.
 */
export const DIABETESNINJA_URL = 'https://diabetesninja.se'

/**
 * The live store listings. If either is ever emptied (the app pulled from a store), the
 * store badges fall back to the plain "coming to" line in home.ts rather than render a
 * button that goes nowhere. diabetesninja.se keeps its own copy of both in
 * web/diabetesninja/src/content/nav.ts; change them together.
 */
export const APP_STORE_URL = 'https://apps.apple.com/se/app/ronin-diabetesdagbok/id6805600437'
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.diabetesninja.ronin'

export const OG_IMAGE = `${SITE_URL}/og-image.png`
export const OG_IMAGE_WIDTH = '1200'
export const OG_IMAGE_HEIGHT = '630'
